import { Flex, IconFont, Menu, Text } from '@byecode/ui'
import type { PageItem } from '@lighthouse/core'
import { LANGUAGE_LIST, SelectLanguage, useAtomData } from '@lighthouse/shared'
import React, { useCallback } from 'react'

import { applicationSettingAtom } from '@/atoms/application/state'
import { useLanguage } from '@/hooks/useApplication'

interface PageOperationProps {
    tree: PageItem
    onCopyPage: (id: string, lang: string) => void
    onRemovePage: () => void
}

export const PageOperation: React.FunctionComponent<PageOperationProps> = ({ tree, onCopyPage, onRemovePage }) => {
    const language = useLanguage()
    const options = useAtomData(
        applicationSettingAtom,
        useCallback(
            s =>
                s?.language?.list
                    ?.map(item => {
                        const LANG = LANGUAGE_LIST.find(lang => lang.lang === item.lang)
                        return {
                            value: item.lang,
                            label: item.title,
                            icon: LANG?.flag
                        }
                    })
                    .filter(item => item.value !== language) ?? [],
            [language]
        )
    )

    return (
        <Menu closeOnItemClick width={204} position="bottom-start">
            <Menu.Target>
                <IconFont type="DotsThree" size={16} color="var(--color-gray-400)" />
            </Menu.Target>
            <Menu.Dropdown>
                <Menu.Item onClick={onRemovePage} icon={<IconFont type="Trash" size={16} color="var(--color-gray-400)" />}>
                    删除
                </Menu.Item>
                {/* <Menu.Item icon={<IconFont type="Trash" size={16} color="var(--color-gray-400)" />}>取消分组</Menu.Item> */}
                <Menu.Item
                    onClick={() => onCopyPage(tree.id, language)}
                    icon={<IconFont type="Duplicate" size={16} color="var(--color-gray-400)" />}
                >
                    复制
                </Menu.Item>
                <SelectLanguage
                    options={options}
                    trigger="hover"
                    position="right-start"
                    targetComponent={
                        <Menu.Item>
                            <Flex justifyContent="space-between">
                                <Flex gap="8px">
                                    <IconFont size={16} type="Copy" color="var(--color-gray-400)" />
                                    <Text size={14}> 复制到其他语言版本 </Text>
                                </Flex>
                                <Flex>
                                    <IconFont size={16} type="ArrowRightSmall" color="var(--color-gray-400)" />
                                </Flex>
                            </Flex>
                        </Menu.Item>
                    }
                    onClick={lang => {
                        onCopyPage(tree.id, lang)
                    }}
                />
            </Menu.Dropdown>
        </Menu>
    )
}
